import React, { useEffect, useState } from 'react';
import './MarketplaceBrokerChatTab.scss';
import { TimelineParty } from '../../../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { Timeline } from '../../../../../../slices/marketplace/timeline/models/timeline.model';
import ClubhouseArea from '../../../../../../clubhouse/clubhouse-area/clubhouse-area';
import { MessageReference } from '../../../../../../clubhouse/models/message-reference';
import { GroupType } from '../../../../../../clubhouse/models/group-type';
import { useStateSelector } from '../../../../../../store/selectors';
import { USER_ROLES } from '../../../../../../utils/constants';
import { useSearchParams } from 'react-router-dom';
import { QueryParams } from '../../../../../../utils/queryParams';
import { NotificationFlagsCategories } from '../../../../../../models/NotificationFlags/NotificationFlagsCategories';
import { EngagementProcessStatus } from '../../../../../../slices/marketplace/timeline/models/enums/engagement-process-status.enum';
import { useSignalR } from '../../../../../../context/WebsocketProvider';

interface MarketplaceBrokerChatTabProps {
    party: TimelineParty;
    timeline: Timeline;
    isReadOnly?: boolean;
}

export const MarketplaceBrokerChatTab = (
    props: MarketplaceBrokerChatTabProps
) => {
    const [messageReference, setMessageReference] = useState<
        MessageReference | undefined
    >();
    // Starts true so the chat shows a loader (not a blank pane) until the
    // clubhouse fetch settles; ClubhouseArea flips it off.
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [isActive, setIsActive] = useState(false);
    const [isForbiddenError, setIsForbiddenError] = useState(false);
    const [isUnexpectedError, setIsUnexpectedError] = useState(false);
    const [searchParams] = useSearchParams();
    const isUserAdmin =
        useStateSelector((s) => s.currentUser.user.roleId) === USER_ROLES.ADMIN;
    const summary = useStateSelector((s) => s.userSummary.summary);
    const isSecondaryUser = summary?.roleId === USER_ROLES.PRACTICE_SECONDARY_USER;
    const { isConnected } = useSignalR();

    // If the chat failed to load while the connection was down, retry as soon
    // as the connection returns instead of parking on the error message.
    useEffect(() => {
        if (isConnected && isUnexpectedError) {
            setIsUnexpectedError(false);
            setIsDataLoading(true);
        }
    }, [isConnected]);

    return (
        <div className="marketplace-broker-chat-tab marketplace-dynamic-container">
            <div className="body_inner_content marketplace-dynamic-container">
                <div className="clubhouse-dynamic-container">
                    <div className="app-pmg-clubhouse app-clubhouse-page">
                        {isForbiddenError ? (
                            <h2 className="error-message">
                                You're not authorized to view this page
                            </h2>
                        ) : isUnexpectedError ? (
                            <h2 className="error-message">
                                Unexpected error occured while fetching Comms
                                Hub
                            </h2>
                        ) : (
                            <div className="flex-container">
                                <ClubhouseArea
                                    messageReference={messageReference}
                                    resetMessageReference={() => {
                                        setMessageReference(undefined);
                                    }}
                                    clubhouseId={
                                        props.timeline.engagementProcess.broker
                                            .brokerChatId
                                    }
                                    groupType={GroupType.MP}
                                    isAdmin={isUserAdmin}
                                    isDataLoading={isDataLoading}
                                    setIsDataLoading={setIsDataLoading}
                                    isActive={isActive}
                                    setIsActive={setIsActive}
                                    setIsForbiddenError={setIsForbiddenError}
                                    refreshClubhouseData={() => {}}
                                    setIsUnexpectedError={setIsUnexpectedError}
                                    isDisabledMessageInput={
                                        props.isReadOnly ||
                                        props.timeline.engagementProcess
                                            .status !==
                                            EngagementProcessStatus.Current
                                    }
                                    isDisabledLikeButton={
                                        props.isReadOnly ||
                                        props.timeline.engagementProcess
                                            .status !==
                                            EngagementProcessStatus.Current
                                    }
                                    isKbAvailable={false}
                                    preselectedDiscussionId={Number(
                                        searchParams.get(
                                            QueryParams.DiscussionIdKey
                                        )
                                    )}
                                    displayTopLikedPosts={() => {}}
                                    customDiscussionsName="Thread"
                                    isDisscussionDeleteIconVisible={!props.isReadOnly && !isSecondaryUser}
                                    customNfPrefix={`${NotificationFlagsCategories.MpCode}.${props.timeline.id}.${NotificationFlagsCategories.CommsHubCode}.${NotificationFlagsCategories.BrokerChatCode}.${props.timeline.engagementProcess.broker.brokerChatId}`}></ClubhouseArea>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
